import { RadioButtonGroup } from '@repo/go-ui';

import type { TrajectoryVerticalDatum } from '../../types/state';

import styles from './vertical-datum-radio.module.scss';

type Props = {
  value: TrajectoryVerticalDatum;
  onChange: (value: TrajectoryVerticalDatum) => void;
};

const ITEMS: { value: TrajectoryVerticalDatum; label: string }[] = [
  { value: 'tvd', label: 'TVD' },
  { value: 'tvdss', label: 'TVDSS' },
];

export function VerticalDatumRadio({ value, onChange }: Props) {
  return <RadioButtonGroup className={styles.group} size="s" value={value} items={ITEMS} onChange={onChange} />;
}
